import PrimaryLink from './PrimaryLink';

export default PrimaryLink;
